// extracted by mini-css-extract-plugin
export var inner = "ParagraphSponsorMePromoCard-module--inner--d0ade";
export var outer = "ParagraphSponsorMePromoCard-module--outer--5273a";